"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TectonicOracleAdapterFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address[]",
                name: "initialDollarAlikeTokens",
                type: "address[]",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_tTokenAddress",
                type: "address",
            },
        ],
        name: "addDollarAlikeToken",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "contract TToken",
                name: "tToken",
                type: "address",
            },
        ],
        name: "getUnderlyingPrice",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "isPriceOracle",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_tTokenAddress",
                type: "address",
            },
            {
                internalType: "contract AggregatorV3Interface",
                name: "_oracleAddress",
                type: "address",
            },
        ],
        name: "registerOracle",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_tTokenAddress",
                type: "address",
            },
        ],
        name: "removeDollarAlikeToken",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_tEtherAddress",
                type: "address",
            },
        ],
        name: "setTEtherAddress",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "tTokenToOracle",
        outputs: [
            {
                internalType: "contract AggregatorV3Interface",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_tTokenAddress",
                type: "address",
            },
        ],
        name: "unregisterOracle",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
class TectonicOracleAdapterFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(initialDollarAlikeTokens, overrides) {
        return super.deploy(initialDollarAlikeTokens, overrides || {});
    }
    getDeployTransaction(initialDollarAlikeTokens, overrides) {
        return super.getDeployTransaction(initialDollarAlikeTokens, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.TectonicOracleAdapterFactory = TectonicOracleAdapterFactory;
TectonicOracleAdapterFactory.bytecode = _bytecode;
TectonicOracleAdapterFactory.abi = _abi;
//# sourceMappingURL=TectonicOracleAdapterFactory.js.map